import { cn } from '@sohanemon/utils';
import type * as React from 'react';

type SrOnlyProps = React.ComponentProps<'span'>;

export function SrOnly({ className, ...props }: SrOnlyProps) {
	return <span className={cn('sr-only', className)} {...props} />;
}
